/** Trainer flows: add workout wizard, analytics dashboard, training plans list. */
export const TRAINER_SCREENS_RU = {
  'addWorkout.title': 'Создание тренировки',
  'addWorkout.step.type': 'Тип',
  'addWorkout.step.typeShort': 'Тип',
  'addWorkout.step.clients': 'Клиенты',
  'addWorkout.step.clientsShort': 'Клиенты',
  'addWorkout.step.datetime': 'Дата/время',
  'addWorkout.step.timeShort': 'Время',
  'addWorkout.step.confirm': 'Подтверждение',
  'addWorkout.step.doneShort': 'Готово',
  'addWorkout.next': 'Далее',
  'addWorkout.create': 'Создать',
  'addWorkout.validating': 'Проверка...',
  'addWorkout.validatingConflicts': 'Проверка конфликтов...',
  'addWorkout.creating': 'Создание...',
  'addWorkout.createGroup': 'Создать групповую тренировку',
  'addWorkout.createSelf': 'Создать самотренировку',
  'addWorkout.createWorkout': 'Создать тренировку',
  'addWorkout.successGroup': 'Групповая тренировка создана для {n} клиентов!',
  'addWorkout.successSelf': 'Самотренировка успешно создана!',
  'addWorkout.successIndividual': 'Тренировка успешно создана!',
  'addWorkout.step1Title': 'Выберите тип тренировки',
  'addWorkout.step1Hint': 'Определите, какую тренировку вы хотите создать',
  'addWorkout.typeIndividual': 'Индивидуальная',
  'addWorkout.typeIndividualDesc': 'Тренировка для одного клиента',
  'addWorkout.typeGroup': 'Групповая',
  'addWorkout.typeGroupDesc': 'Тренировка для 2–10 клиентов',
  'addWorkout.typeSelfDesc': 'Тренировка для тренера',
  'addWorkout.hintIndividual':
    'Вы выбрали индивидуальную тренировку. На следующем шаге выберите клиента.',
  'addWorkout.hintGroup':
    'Вы выбрали групповую тренировку. На следующем шаге выберите клиентов (минимум 2, максимум 10).',
  'addWorkout.hintSelf':
    'Вы выбрали самотренировку. На следующем шаге пропустите выбор клиентов.',
  'addWorkout.step2Title': 'Выберите клиентов',
  'addWorkout.step2Individual': 'Выберите клиента для индивидуальной тренировки',
  'addWorkout.step2Group': 'Выберите клиентов для групповой тренировки',
  'addWorkout.step2Self': 'Самотренировка не требует выбора клиентов',
  'addWorkout.clientTooltip': 'Начните вводить имя клиента для поиска в базе данных',
  'addWorkout.clientLabel': 'Клиент *',
  'addWorkout.clientPlaceholder': 'Введите имя клиента...',
  'addWorkout.clientSearchHint': 'Начните вводить имя клиента для поиска в базе данных',
  'addWorkout.groupTooltip': 'Для групп: 2–10 клиентов',
  'addWorkout.groupClientsLabel': 'Клиенты для групповой тренировки *',
  'addWorkout.groupClientPlaceholder': 'Введите имя клиента для добавления...',
  'addWorkout.groupPickHint': 'Выберите клиентов для групповой тренировки (минимум 2, максимум 10)',
  'addWorkout.groupSelected': 'Выбрано клиентов: {n}/10',
  'addWorkout.selfSectionLabel': 'Самотренировка',
  'addWorkout.selfNoClient': 'Тренировка для тренера — без клиента',
  'addWorkout.step3Title': 'Выберите дату и время',
  'addWorkout.step3Hint': 'Установите дату и время тренировки',
  'addWorkout.dateTooltip': 'Выберите дату тренировки',
  'addWorkout.dateLabel': 'Дата *',
  'addWorkout.pickDate': 'Выберите дату',
  'addWorkout.pickDateAria': 'Выберите дату',
  'addWorkout.timeBlockTooltip':
    'Время начала и окончания тренировки. Перетащите для корректировки времени.',
  'addWorkout.workoutTimeLabel': 'Время тренировки *',
  'addWorkout.startTime': 'Время начала',
  'addWorkout.endTime': 'Время окончания',
  'addWorkout.endTimePlaceholder': 'Автоматически +1 час',
  'addWorkout.endTimeHint': 'По умолчанию устанавливается +1 час от времени начала',
  'addWorkout.recurrenceTooltip': 'Выберите тип повторения тренировки',
  'addWorkout.recurrenceLabel': 'Повторение',
  'addWorkout.recurrencePlaceholder': 'Выберите тип повторения',
  'addWorkout.recurrenceNone': 'Без повторения',
  'addWorkout.recurrenceWeekly': 'Еженедельно',
  'addWorkout.weekdaysTooltip': 'Выберите дни недели для повторения',
  'addWorkout.weekdaysLabel': 'Дни недели',
  'addWorkout.weekdaysHint': 'Выберите дни недели для повторения тренировки',
  'addWorkout.step4Title': 'Подтверждение',
  'addWorkout.step4Hint': 'Проверьте данные и добавьте комментарий',
  'addWorkout.detailsTitle': 'Детали тренировки',
  'addWorkout.fieldType': 'Тип:',
  'addWorkout.fieldClient': 'Клиент:',
  'addWorkout.fieldClients': 'Клиенты:',
  'addWorkout.fieldDate': 'Дата:',
  'addWorkout.fieldTime': 'Время:',
  'addWorkout.fieldRecurrence': 'Повторение:',
  'addWorkout.notSelected': 'Не выбран',
  'addWorkout.dateNotSelected': 'Не выбрана',
  'addWorkout.clientsCount': '{n} клиентов',
  'addWorkout.commentTooltip': 'Добавьте комментарий к тренировке (необязательно)',
  'addWorkout.commentLabel': 'Комментарий',
  'addWorkout.commentPlaceholder': 'Введите комментарий',
  'addWorkout.errMaxGroup': 'Максимальное количество клиентов в групповой тренировке: 10',
  'addWorkout.errRequired': 'Заполните все обязательные поля',
  'addWorkout.errGroupPickOne': 'Выберите хотя бы одного клиента для групповой тренировки',
  'addWorkout.errGroupMin2':
    'Для групповой тренировки нужно выбрать минимум 2 клиента. Переключитесь на индивидуальную тренировку или добавьте ещё клиентов.',
  'addWorkout.errDateTime': 'Заполните дату и время тренировки',
  'addWorkout.errTimeConflict': 'Не удалось создать тренировку: конфликт времени',
  'addWorkout.errCreate': 'Ошибка при создании тренировки',
  'addWorkout.errAlreadyCreated': 'Тренировка уже была создана',
  'addWorkout.errRecurringConflict':
    'Конфликт при создании повторяющейся тренировки на {date} в {time}. Занято: {clients}',
  'addWorkout.errMerge': 'Ошибка при объединении тренировок',
  'addWorkout.conflictDialogTitle': 'На это время уже есть другая тренировка',
  'addWorkout.conflictDialogAsk': 'Создать тренировку всё равно?',
  'addWorkout.conflictingHeading': 'Пересекающиеся тренировки:',
  'addWorkout.conflictClientFallback': 'Клиент',
  'addWorkout.conflictNo': 'Нет',
  'addWorkout.conflictYes': 'Создать всё равно',
  'addWorkout.conflictWhen': '{date} в {time}',

  'mergeWorkout.title': 'Объединить тренировки?',
  'mergeWorkout.lead': 'На это время уже запланированы тренировки для следующих клиентов:',
  'mergeWorkout.question': 'Хотите объединить тренировки в групповую на {date} в {time}?',
  'mergeWorkout.fallbackDate': 'указанную дату',
  'mergeWorkout.fallbackTime': 'указанное время',
  'mergeWorkout.unknownClients': 'неизвестных клиентов',
  'mergeWorkout.merge': 'Объединить',

  'analytics.errBadFormat': 'Неверный формат данных от сервера',
  'analytics.errLoad': 'Ошибка при загрузке аналитики',
  'analytics.loading': 'Загрузка аналитики...',
  'analytics.noData': 'Нет данных для отображения',
  'analytics.totalRevenue': 'Общий доход',
  'analytics.prevMonth': 'Предыдущий месяц',
  'analytics.nextMonth': 'Следующий месяц',
  'analytics.moreCurrencies': 'Ещё валюты',
  'analytics.newClients': 'Новых клиентов',
  'analytics.workouts': 'Тренировок',
  'analytics.completed': 'Завершено',
  'analytics.awaitingPayment': 'Ожидают оплаты',
  'analytics.revenueByMonth': 'Доход по месяцам',
  'analytics.emptyChart': 'Нет данных',
  'analytics.colMonth': 'Месяц',
  'analytics.colAmount': 'Сумма',
  'analytics.hide': 'Скрыть',
  'analytics.showMore': 'Показать ещё',
  'analytics.unpaidTitle': 'Ожидают оплаты',
  'analytics.unpaidSubtitle': 'Список неоплаченных тренировок',
  'analytics.unpaidEmpty': 'Нет тренировок, ожидающих оплаты',
  'analytics.unknownClient': 'Неизвестный клиент',
  'analytics.addPayment': 'Добавить оплату',
  'analytics.dateNotSet': 'Дата не указана',
  'analytics.timeSuffix': ' в {time}',
  'analytics.expand': 'Показать ещё',
  'analytics.collapse': 'Скрыть',
  'analytics.addPaymentTitle': 'Добавить оплату',
  'analytics.clientLabel': 'Клиент:',

  'plansScreen.title': 'Планы тренировок',
  'plansScreen.exerciseDictTitle': 'Справочник упражнений',
  'plansScreen.addPlan': 'Добавить план',
  'plansScreen.searchPlaceholder': 'Поиск планов тренировок...',
  'plansScreen.allGroups': 'Все группы',
  'plansScreen.loading': 'Загрузка...',
  'plansScreen.empty': 'Нет планов тренировок',
  'plansScreen.addPlanLarge': 'Добавить план тренировки',
  'plansScreen.noneMatch': 'Планы не найдены',
  'plansScreen.resetFilters': 'Сбросить фильтры',
  'plansScreen.exerciseCount': '{n} упражнений',
  'plansScreen.noExercisesInPlan': 'Нет упражнений в этом плане',
  'plansScreen.addExercises': 'Добавить упражнения',
  'plansScreen.deleteTitle': 'Удалить план?',
  'plansScreen.deleteDesc':
    'Вы уверены, что хотите удалить план «{name}»? Это действие нельзя отменить.',
  'plansScreen.setPattern': '{reps} × {weight}',
};

export const TRAINER_SCREENS_EN = {
  'addWorkout.title': 'New workout',
  'addWorkout.step.type': 'Type',
  'addWorkout.step.typeShort': 'Type',
  'addWorkout.step.clients': 'Clients',
  'addWorkout.step.clientsShort': 'Clients',
  'addWorkout.step.datetime': 'Date & time',
  'addWorkout.step.timeShort': 'Time',
  'addWorkout.step.confirm': 'Review',
  'addWorkout.step.doneShort': 'Done',
  'addWorkout.next': 'Next',
  'addWorkout.create': 'Create',
  'addWorkout.validating': 'Checking...',
  'addWorkout.validatingConflicts': 'Checking conflicts...',
  'addWorkout.creating': 'Creating...',
  'addWorkout.createGroup': 'Create group workout',
  'addWorkout.createSelf': 'Create solo workout',
  'addWorkout.createWorkout': 'Create workout',
  'addWorkout.successGroup': 'Group workout created for {n} clients!',
  'addWorkout.successSelf': 'Solo workout created!',
  'addWorkout.successIndividual': 'Workout created!',
  'addWorkout.step1Title': 'Choose workout type',
  'addWorkout.step1Hint': 'Pick the kind of session you’re scheduling',
  'addWorkout.typeIndividual': '1:1',
  'addWorkout.typeIndividualDesc': 'One client',
  'addWorkout.typeGroup': 'Group',
  'addWorkout.typeGroupDesc': 'Two to ten clients',
  'addWorkout.typeSelfDesc': 'For yourself',
  'addWorkout.hintIndividual': 'You chose a 1:1 session. Next, pick the client.',
  'addWorkout.hintGroup':
    'You chose a group session. Next, pick clients (minimum 2, maximum 10).',
  'addWorkout.hintSelf': 'You chose a solo session. You can skip client selection on the next step.',
  'addWorkout.step2Title': 'Clients',
  'addWorkout.step2Individual': 'Pick the client for this session',
  'addWorkout.step2Group': 'Pick clients for the group',
  'addWorkout.step2Self': 'No client is needed for a solo session',
  'addWorkout.clientTooltip': 'Start typing a name to search your client list',
  'addWorkout.clientLabel': 'Client *',
  'addWorkout.clientPlaceholder': 'Type client name...',
  'addWorkout.clientSearchHint': 'Start typing to search your client list',
  'addWorkout.groupTooltip': 'Groups: 2–10 clients',
  'addWorkout.groupClientsLabel': 'Group clients *',
  'addWorkout.groupClientPlaceholder': 'Type a name to add…',
  'addWorkout.groupPickHint': 'Add between 2 and 10 clients for a group session',
  'addWorkout.groupSelected': 'Selected: {n}/10',
  'addWorkout.selfSectionLabel': 'Solo workout',
  'addWorkout.selfNoClient': 'Trainer-only session — no client',
  'addWorkout.step3Title': 'Date & time',
  'addWorkout.step3Hint': 'Set when the workout happens',
  'addWorkout.dateTooltip': 'Pick the workout date',
  'addWorkout.dateLabel': 'Date *',
  'addWorkout.pickDate': 'Pick a date',
  'addWorkout.pickDateAria': 'Pick a date',
  'addWorkout.timeBlockTooltip': 'Start and end time. Drag handles to adjust.',
  'addWorkout.workoutTimeLabel': 'Workout time *',
  'addWorkout.startTime': 'Start',
  'addWorkout.endTime': 'End',
  'addWorkout.endTimePlaceholder': 'Auto +1 hour',
  'addWorkout.endTimeHint': 'End time defaults to one hour after start',
  'addWorkout.recurrenceTooltip': 'How often this session repeats',
  'addWorkout.recurrenceLabel': 'Repeat',
  'addWorkout.recurrencePlaceholder': 'Repeat schedule',
  'addWorkout.recurrenceNone': 'Does not repeat',
  'addWorkout.recurrenceWeekly': 'Weekly',
  'addWorkout.weekdaysTooltip': 'Pick weekdays for the repetition',
  'addWorkout.weekdaysLabel': 'Weekdays',
  'addWorkout.weekdaysHint': 'Select days when this workout repeats',
  'addWorkout.step4Title': 'Review',
  'addWorkout.step4Hint': 'Check details and add a note if needed',
  'addWorkout.detailsTitle': 'Details',
  'addWorkout.fieldType': 'Type:',
  'addWorkout.fieldClient': 'Client:',
  'addWorkout.fieldClients': 'Clients:',
  'addWorkout.fieldDate': 'Date:',
  'addWorkout.fieldTime': 'Time:',
  'addWorkout.fieldRecurrence': 'Repeat:',
  'addWorkout.notSelected': 'Not selected',
  'addWorkout.dateNotSelected': 'Not selected',
  'addWorkout.clientsCount': '{n} clients',
  'addWorkout.commentTooltip': 'Optional note for this workout',
  'addWorkout.commentLabel': 'Note',
  'addWorkout.commentPlaceholder': 'Enter a comment',
  'addWorkout.errMaxGroup': 'A group workout can include at most 10 clients',
  'addWorkout.errRequired': 'Fill in all required fields',
  'addWorkout.errGroupPickOne': 'Select at least one client for the group',
  'addWorkout.errGroupMin2':
    'Group workouts need at least two clients. Switch to 1:1 or add more clients.',
  'addWorkout.errDateTime': 'Set date and time for the workout',
  'addWorkout.errTimeConflict': 'Couldn’t create workout: time conflict',
  'addWorkout.errCreate': 'Couldn’t create workout',
  'addWorkout.errAlreadyCreated': 'Workout was already created',
  'addWorkout.errRecurringConflict':
    'Conflict when creating repeating workout on {date} at {time}. Taken by: {clients}',
  'addWorkout.errMerge': 'Couldn’t merge workouts',
  'addWorkout.conflictDialogTitle': 'Another workout is already at this time',
  'addWorkout.conflictDialogAsk': 'Create this workout anyway?',
  'addWorkout.conflictingHeading': 'Conflicting workouts:',
  'addWorkout.conflictClientFallback': 'Client',
  'addWorkout.conflictNo': 'No',
  'addWorkout.conflictYes': 'Create anyway',
  'addWorkout.conflictWhen': '{date} at {time}',

  'mergeWorkout.title': 'Merge workouts?',
  'mergeWorkout.lead': 'These clients already have workouts at this time:',
  'mergeWorkout.question': 'Merge them into one group workout on {date} at {time}?',
  'mergeWorkout.fallbackDate': 'the selected date',
  'mergeWorkout.fallbackTime': 'the selected time',
  'mergeWorkout.unknownClients': 'unknown clients',
  'mergeWorkout.merge': 'Merge',

  'analytics.errBadFormat': 'Invalid data from server',
  'analytics.errLoad': 'Couldn’t load analytics',
  'analytics.loading': 'Loading analytics...',
  'analytics.noData': 'Nothing to show yet',
  'analytics.totalRevenue': 'Total revenue',
  'analytics.prevMonth': 'Previous month',
  'analytics.nextMonth': 'Next month',
  'analytics.moreCurrencies': 'More currencies',
  'analytics.newClients': 'New clients',
  'analytics.workouts': 'Workouts',
  'analytics.completed': 'Completed',
  'analytics.awaitingPayment': 'Awaiting payment',
  'analytics.revenueByMonth': 'Revenue by month',
  'analytics.emptyChart': 'No data',
  'analytics.colMonth': 'Month',
  'analytics.colAmount': 'Amount',
  'analytics.hide': 'Hide',
  'analytics.showMore': 'Show more',
  'analytics.unpaidTitle': 'Awaiting payment',
  'analytics.unpaidSubtitle': 'Unpaid sessions',
  'analytics.unpaidEmpty': 'No unpaid sessions',
  'analytics.unknownClient': 'Unknown client',
  'analytics.addPayment': 'Add payment',
  'analytics.dateNotSet': 'Date not set',
  'analytics.timeSuffix': ' at {time}',
  'analytics.expand': 'Show more',
  'analytics.collapse': 'Hide',
  'analytics.addPaymentTitle': 'Add payment',
  'analytics.clientLabel': 'Client:',

  'plansScreen.title': 'Training plans',
  'plansScreen.exerciseDictTitle': 'Exercise reference',
  'plansScreen.addPlan': 'Add plan',
  'plansScreen.searchPlaceholder': 'Search training plans...',
  'plansScreen.allGroups': 'All muscle groups',
  'plansScreen.loading': 'Loading...',
  'plansScreen.empty': 'No training plans yet',
  'plansScreen.addPlanLarge': 'Create a training plan',
  'plansScreen.noneMatch': 'No plans match filters',
  'plansScreen.resetFilters': 'Reset filters',
  'plansScreen.exerciseCount': '{n} exercises',
  'plansScreen.noExercisesInPlan': 'No exercises in this plan',
  'plansScreen.addExercises': 'Add exercises',
  'plansScreen.deleteTitle': 'Delete plan?',
  'plansScreen.deleteDesc':
    'Delete plan “{name}”? This can’t be undone.',
  'plansScreen.setPattern': '{reps} × {weight}',
};
